import React, { Component } from "react";
import i18next from "i18next";
import { withTranslation, Trans } from "react-i18next";
import i18n from "../../config/i18n";
import classnames from "classnames";
import Loader from "../loaders/loader";
import Services from "../../api/api";
import { connect } from "react-redux";
import { Document, Page } from "react-pdf";
import Iframe from 'react-iframe'
import ReactPlayer from "react-player";
import Slider from "react-slick";
import Button from '@material-ui/core/Button';

import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Accordian from "../Accordian/Accordian";
import { removeSpacetoLowerCase } from '../../api/helper'
import OffileDb from '../../config/pouchDB';
import { gaLogEvent } from "../../helpers/analytics";

class Knowledge extends Component {
  constructor(props) {
    super(props);
    this.state = {
      knowledge: [],
      expanded: false,
      subExpanded: false,
      knowledgeAccordian: [],
      selectedAccordianObj: {},
      selectedIndex: null,
      newKnowArr: [],
      firstMount: true,
      isPlay: false,
      currentVideoSlide: 0,
      videoFlag: []
      // communityId: '',
      // languageId: ''
    };
    this.nextClick = this.nextClick.bind(this);
    this.afterChange = this.afterChange.bind(this);
    this.onPlay = this.onPlay.bind(this);
    this.onPause = this.onPause.bind(this);
  }

  componentDidMount() {
    

    OffileDb.setDatabase()
    this.setState(
      {
        // communityId: this.props.communityuid,
        // languageId: this.props.langId,
      },
      () => {
        this.getKnowledgeableDetail(this.props.parentKnowledgeObj);
        
      }
    );
    
  }

  getKnowledgeableDetail(parentObj) {
    this.loadOfflineData(parentObj)
    
  }


  getApiData(parentObj) {
    if (navigator.onLine) {
      let params = {
        communityId: this.props.communityuid,
        contentId: parentObj.contentId,
        languageId: this.props.langId,
        roleId: JSON.parse(localStorage.getItem("obj")).roleId,
        userId: JSON.parse(localStorage.getItem("obj")).userId,
      };
      var dbId = 'KnowledgeableDetail-' + parentObj.contentId;
      console.log("getKnowledgeableDetail getRoleWiseContent>>", params);
      Services.getRoleWiseContent(params).then((res) => {
        try{
          console.log("getKnowledgeableDetail getRoleWiseContent>>", res);
          if (res.data.status == 200) {
            if (this.state.firstMount) {
              this.setState(
                {
                  knowledge: res.data.data.childs,
                  newKnowArr: res.data.data.childs,
                  firstMount: false,
                },
                () => {
                  // this.setKnowledgableChildDetail(res.data.data);
                }
              );
            } else {
              this.setState(
                {
                  knowledge: res.data.data.childs,
                },
                () => {
                  this.setKnowledgableChildDetail(res.data.data);
                }
              );
            }
            OffileDb.setData(dbId, res.data.data)
          }
        }catch(err){
          console.log("err::", err)
        }
      });
    }
  }

  loadOfflineData(parentObj) {
    var that = this
    var dbId = 'KnowledgeableDetail-' + parentObj.contentId;
    OffileDb.getData(dbId).then(function (result) {
      console.log(result)
      if (!result.status && result.status != 404) {
        if (that.state.firstMount) {
          that.setState(
            {
              knowledge: result.data.childs,
              newKnowArr: result.data.childs,
              firstMount: false,
            },
            () => {
              // this.setKnowledgableChildDetail(res.data.data);
            }
          );
        } else {
          that.setState(
            {
              knowledge: result.data.childs,
            },
            () => {
              that.setKnowledgableChildDetail(result.data);
            }
          );
        }
      } else {
        that.getApiData(parentObj)
      }
    });

  }

  iterateChild(parentobj, selectedAccordianObj) {
    let updatedchild = [];

    if (parentobj.childs && parentobj.childs.length == 0) {
      parentobj.childs.map((childobj, index) => {
        if (childobj.contentId == selectedAccordianObj.contentobj.contentId) {
          updatedchild = Object.assign(childobj, { childs: childobj.childs });
        } else {
          this.iterateChild(childobj);
        }
      });
    }
    console.log("iterateChild>>", updatedchild);
    return updatedchild;
  }

  setKnowledgableChildDetail(childObj) {
    let updated = [...this.state.newKnowArr];
    let selectedAccordianObj = this.state.selectedAccordianObj;
    let selectedIndex = this.state.selectedIndex;

    updated.forEach((parentobj, parentIndex) => {
      if (Object.keys(selectedAccordianObj).length == 0) {
        parentobj = Object.assign({}, { childs: childObj.childs });
        return;
      } else {
        if (parentobj.contentId == selectedAccordianObj.contentobj.contentId) {
          parentobj = Object.assign(parentobj, { childs: childObj.childs });
        } else {
          parentobj = this.iterateChild(parentobj, selectedAccordianObj);
          // if(parentobj.childs) {
          //   parentobj = this.iterateChild(parentobj, selectedAccordianObj)
          // } else {
          //   parentobj = Object.assign(parentobj, {childs: childObj.childs})
          // }
        }
      }
    });
    this.setState({
      newKnowArr: updated,
    });
  }

  handleOnClickAccordian(contentobj, index) {
    // if(!contentobj.hasChild) {
    //   return;
    // }
    //store the object of selected node and index
    console.log(contentobj)
    try{
      gaLogEvent("Information "+contentobj.contentName, '', '');
    }catch(err){
      console.log("err::", err);
    }
    this.setState(
      {
        selectedAccordianObj: { contentobj: contentobj, selectedIndex: index },
      },
      () => {
        if (contentobj.hasChild) {
          this.getKnowledgeableDetail(contentobj);
          
        }
      }
    );
  }

  handleChange = (panel) => (event, isExpanded) => {
    this.setState({
      expanded: isExpanded ? panel : null,
    });
  };

  handleChangeSubExpand = (panel) => (event, isExpanded) => {
    this.setState({
      subExpanded: isExpanded ? panel : null,
    });
  };

  // renderAccordian() {
  //   let self = this;
  //   let knowledgeArr = [...this.state.knowledge];

  //   let knowledgeAccordian = [];
  //   knowledgeArr.map((knowledgeObj, index) => {
  //     knowledgeAccordian.push(
  //       <Accordian
  //         expandedobj={this.state.expanded}
  //         contentObj={knowledgeObj}
  //         selectedAccordian={(contentObj, event, newExpanded) =>
  //           this.handleChange(contentObj, event, newExpanded)
  //         }
  //       />
  //     );
  //   });

  //   return knowledgeAccordian;
  // }


  nextClick(e) {
    var arr = this.state.videoFlag
    arr[e] = false;
    this.setState({
      videoFlag: arr
    })
  }

  afterChange(current) {
    // console.log(current)
    //console.log(this.state.videoFlag)
    // this.setState({
    //   currentVideoSlide: current,
    //   isPlay:false
    // })
  }

  onPlay(key) {
    var arr = this.state.videoFlag
    arr[key] = true;
    // this.setState({
    //   videoFlag: arr
    // })
    //this.setState({isPlay: true})
  }


  onPause(key) {
    // var arr = this.state.videoFlag
    // arr[key] = false;
    // this.setState({
    //   videoFlag: arr
    // })
    //this.setState({isPlay: false})
  }

  getHttpsUrl(iconurl) {
    var spliurtl = iconurl.split("://")
    let myUrl = spliurtl.length > 1 ? "https://" + spliurtl[1] : "https://" + spliurtl[0];
    return myUrl;
  }

  openPdf(url){
    console.log(url)
    window.open(url, '_system', 'location=no');
  }

  renderKnowledgeAccordian() {
    let self = this;
    const { t } = this.props;
    // let knowledgeArr = [...this.state.knowledge];
    let knowledgeArr = [...this.state.newKnowArr];

    let knowledgeAccordian = [];


    var settings = {
      dots: true,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      swipeToSlide: true,
      adaptiveHeight: true,
      slidesToScroll: 1,
      fade: false,
      beforeChange: this.nextClick,
      afterChange: this.afterChange,
    };

    knowledgeArr.map((knowledgeObj, index) => {
      var htmlDoc = "";
      if (knowledgeObj.contentList && knowledgeObj.contentList.length !== 0) {
        if (knowledgeObj.contentList[0].description) {
          htmlDoc = knowledgeObj.contentList[0].description;
        } else if (knowledgeObj.contentList[0].shortDesc) {
          htmlDoc = knowledgeObj.contentList[0].shortDesc;
        }
      }
      knowledgeAccordian.push(
        <Accordion
          className="accordian-detail"
          key={knowledgeObj.contentName}
          expanded={self.state.expanded === knowledgeObj.contentName}
          onChange={self.handleChange(knowledgeObj.contentName)}
          onClick={() => this.handleOnClickAccordian(knowledgeObj, index)}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
            className="gklistdetails-accordion-headerlink"
            style={{ background: this.props.componentbgcolor }}
          >
            <Typography className="gklistdetails-accordion-header">
              {knowledgeObj.contentName}
            </Typography>
          </AccordionSummary>
          <AccordionDetails className="gklistdetails-summary">
            <Typography>
              <div className="gklistdetails-root">
                {knowledgeObj.contentList &&
                  knowledgeObj.contentList.length > 0 &&
                  knowledgeObj.contentList[0].infographics &&
                  knowledgeObj.contentList[0].infographics.video &&
                  knowledgeObj.contentList[0].infographics.video.length > 0 && (
                    <p className="text-center championvideobig championimge">
                      <Slider {...settings} className="slider">
                        {
                          knowledgeObj.contentList[0].infographics.video.map((url, key) => {
                            var controflg = knowledgeObj.contentList[0].infographics.video[key].includes('vimeo')
                            return (
                              <ReactPlayer
                                url={knowledgeObj.contentList[0].infographics.video[key]}
                                width={"100%"}
                                height={200}

                                style={{ marginTop: "0px" }}
                                playing={this.state.videoFlag[key]}
                                onPlay={() => this.onPlay(key)}
                                onPause={() => this.onPause(key)}
                                //onPlay={this.onPlay}
                                //onPause={this.onPause}
                                controls={controflg}
                              />
                              // <KnowledgeDetailVideo currentVideoSlide={this.state.currentVideoSlide == key} number={key} url={state.contentList[0].infographics.video[key]} playVid={this.state.isPlay}></KnowledgeDetailVideo>
                            )
                          }
                          )}
                      </Slider>
                    </p>
                  )
                }

                {knowledgeObj.contentList &&
                  knowledgeObj.contentList.length > 0 &&
                  knowledgeObj.contentList[0].infographics &&
                  knowledgeObj.contentList[0].infographics.image &&
                  knowledgeObj.contentList[0].infographics.image.length > 0 && (
                    <p className="text-center championvideobig championimge">
                      <Slider {...settings} className="slider">
                        {
                          knowledgeObj.contentList[0].infographics.image.map(
                            (url, key) => {
                              let iurl  = this.getHttpsUrl(knowledgeObj.contentList[0].infographics.image[key])
                              return (<img src={iurl} class="" />)
                            }
                          )}
                      </Slider>
                    </p>
                  )
                }
                <div dangerouslySetInnerHTML={{ __html: htmlDoc }} />
                {knowledgeObj.contentList &&
                  knowledgeObj.contentList.length > 0 &&
                  knowledgeObj.contentList[0].infographics &&
                  Object.keys(knowledgeObj.contentList[0].infographics).length >
                  0 &&
                  knowledgeObj.contentList[0].infographics.pdf &&
                  knowledgeObj.contentList[0].infographics.pdf.length > 0 &&
                  knowledgeObj.contentList[0].infographics.pdf.map((pdf) => {
                    return (
                      window.cordova ? 
                      <Button variant="contained" onClick={()=> this.openPdf(pdf)}>{t('Open Pdf')}</Button> :
                      <Iframe url={pdf}
                        width={"100%"}
                        height="450px"
                        id={removeSpacetoLowerCase(knowledgeObj.contentName)}
                        className="myClassname"
                        display="initial"
                        position="relative" />
                    );
                  })}

                {/* {knowledgeObj.contentList.length > 0 && knowledgeObj.contentList[0].infographics} */}
                {/* {knowledgeObj.contentList &&
                  knowledgeObj.contentList.length > 0 &&
                  knowledgeObj.contentList[0].infographics &&
                  Object.keys(knowledgeObj.contentList[0].infographics).length >
                    0 &&
                  knowledgeObj.contentList[0].infographics.pdf &&
                  knowledgeObj.contentList[0].infographics.pdf.length > 0 &&
                  knowledgeObj.contentList[0].infographics.pdf.map((pdf) => {
                    console.log("pdfpdfpdfpdfpdf", pdf);
                    return (
                      <Document
                        file={{
                          url: 'http://example.com/sample.pdf',
                          httpHeaders: {
                            'Access-Control-Allow-Origin': '*'
                          }
                        }}
                      >
                        <Page pageNumber={1} />
                      </Document>
                    );
                  })} */}
                {/* {knowledgeObj.childs &&
                  self.renderSubDetailAccordian(knowledgeObj.childs)} */}
                {knowledgeObj.childs && (
                  <Knowledge
                    {...this.props}
                    parentKnowledgeObj={knowledgeObj}
                  />
                )}
              </div>
            </Typography>
          </AccordionDetails >
        </Accordion >
      );
    });

    return knowledgeAccordian;
  }

  renderSubDetailAccordian(knowledgeArr) {
    return knowledgeArr.map((knowledgeObj, index) => {
      var htmlDoc = "<div></div>";
      if (knowledgeObj.contentList[0].description) {
        htmlDoc = knowledgeObj.contentList[0].description;
      } else {
        htmlDoc = knowledgeObj.contentList[0].shortDesc;
      }
      return (
        <Accordion
          key={knowledgeObj.contentName}
          expanded={this.state.subExpanded === knowledgeObj.contentName}
          onChange={this.handleChangeSubExpand(knowledgeObj.contentName)}
          onClick={() => this.handleOnClickAccordian(knowledgeObj, index)}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
            className="gklistsubdetails-accordion-headerlink"
          >
            <Typography className="gklistdetails-accordion-header">
              {knowledgeObj.contentName}
            </Typography>
          </AccordionSummary>
          <AccordionDetails className="gklistsubdetails-summary">
            <div dangerouslySetInnerHTML={{ __html: htmlDoc }} />
          </AccordionDetails>
        </Accordion>
      );
    });
  }

  render() {
    // console.log("knowledge>>>", this.state);
    return (
      <div className="gklistdetails-root">
        {this.renderKnowledgeAccordian()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  let { storeState } = state;
  return {
    communityuid: storeState.communityId,
    langId: storeState.langId,
    componentbgcolor: storeState.componentbgcolor
  };
};

let newKnowledge = withTranslation()(Knowledge);
export default connect(mapStateToProps, {})(newKnowledge);
